import Velocity from 'velocity-animate'

export default function initBondCards () {
  const buttons = document.querySelectorAll('.bond-cross')
  const bonds = document.querySelectorAll('.issues-content__container ._bond .issues-bond')
  const navItems = document.querySelectorAll('.issues-nav__item')
  const navItem = document.querySelector('.issues-nav__item_active')
  const navInner = document.querySelector('.issues-nav__container')
  const navContainer = document.querySelector('.issues-nav')

  if(!navItems.length) return

  buttons.forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault()
      const headerHeight = navContainer.getBoundingClientRect().height;

      bonds.forEach(element => {
        element.classList.remove('issues-bond_opened')
      })

      el.closest('.issues-bond').classList.add('issues-bond_opened')

      const elContainer = el.closest('.issues-bond');
      window.scrollTo(0, getCoords(elContainer).top - headerHeight)
    })
  })

  alignActiveNavItem(navItem, navInner, navContainer)
}

function alignActiveNavItem (item, inner, container) {
  if (window.innerWidth > 1000 || !inner) return

  const leftEdge = inner.offsetLeft
  const rightEdge = inner.offsetLeft + inner.offsetWidth
  const navItemLeft = item.getBoundingClientRect().left
  const navItemRight = item.getBoundingClientRect().right

  const outOfBoundaries = (navItemLeft < leftEdge) || (navItemRight > rightEdge)

  if (outOfBoundaries) {
    const options = {
      container,
      duration: 400,
      axis: 'x'
    }

    if (navItemLeft < leftEdge) {
      options.offset = -leftEdge
    }

    Velocity(item, 'scroll', options)
  }
}

function getCoords(elem) {
  let box = elem.getBoundingClientRect();

  return {
    top: box.top + pageYOffset,
    left: box.left + pageXOffset
  };
}
